import React from "react";
import { getFormattedPrice } from "../../../services/helper";

const PaymentSummary = ({ total, remainingBalance, payments }) => (
  <div className="payment-summary mb-2" style={{ fontSize: "12px" }}>
    <div className="d-flex justify-content-between">
      <span style={{ color: "white" }}>Total:</span>
      <span style={{ color: "white" }}>{getFormattedPrice(total)}</span>
    </div>
    <div className="d-flex justify-content-between">
      <span style={{ color: "white" }}>Balance:</span>
      <span style={{ color: "white" }}>{getFormattedPrice(remainingBalance)}</span>
    </div>
    {payments.length > 0 && (
      <div className="mt-1">
        {payments.map((payment) => (
          <div key={payment.id} className="d-flex justify-content-between" style={{ fontSize: "10px" }}>
            <span style={{ color: "#ccc" }}>{payment.type}:</span>
            <span style={{ color: "#ccc" }}>{getFormattedPrice(payment.amount)}</span>
          </div>
        ))}
      </div>
    )}
  </div>
);

export default PaymentSummary;